import vars from '../helpers';

const $popup = vars.$document.find('.js-footer-team-popup');
const $buttonOpen = vars.$document.find('.js-footer-team-button-open');
const $buttonClose = vars.$document.find('.js-footer-team-button-close');

const init = () => {
	if (!vars.isMobile()) {
		return;
	}

	$buttonOpen.on('click', () => {
		$popup.addClass('isShown');
	});

	$buttonClose.on('click', () => {
		$popup.removeClass('isShown');
	});

	// Ниже обычная логика
	// vars.$document.on('click', (e) => {
	// 	if ($popup.hasClass('isShown') && !$(e.target).hasClass('js-footer-team-popup') || $popup.hasClass('isShown') && !$(e.target).closest('.js-footer-team-popup').length) {
	// 		$popup.removeClass('isShown');
	// 	}

	// 	if (!$popup.hasClass('isShown') && $(e.target).hasClass('js-footer-team-button')) {
	// 		$popup.addClass('isShown');
	// 	}
	// });

	// vars.$window.on('scroll resize', () => {
	// 	$popup.removeClass('isShown');
	// });
};

const destroy = () => {
	if (!vars.isMobile()) {
		return;
	}

	$popup.removeClass('isShown');
};

export default {
	init,
	destroy,
};
